module.exports = __webpack_public_path__ + "img/1.07d2359e.svg";